var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewProjectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F5F5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.714 22.418h6a2.4 2.4 0 012.4 2.4v6a2.4 2.4 0 01-2.4 2.4h-6a2.4 2.4 0 01-2.4-2.4v-6a2.4 2.4 0 012.4-2.4zm6 13.2h-6a2.4 2.4 0 00-2.4 2.4v6a2.4 2.4 0 002.4 2.4h6a2.4 2.4 0 002.4-2.4v-6a2.4 2.4 0 00-2.4-2.4zm-6 8.4v-6h6v6h-6zm0-13.2v-6h6v6h-6zm13.2-8.4h6a2.4 2.4 0 012.4 2.4v6a2.4 2.4 0 01-2.4 2.4h-6a2.4 2.4 0 01-2.4-2.4v-6a2.4 2.4 0 012.4-2.4zm0 8.4v-6h6v6h-6z",
    fill: "#9BAEF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.815 36.918v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2zm7 3v2h6v11h-11v-6h-2v6a2 2 0 002 2h11a2 2 0 002-2v-11a2 2 0 00-2-2h-6z",
    fill: "#506BCA"
  })));
}
export default __webpack_public_path__ + "media/virtualStagingContractMedia/newProjectIcon-3072e2e9.svg";
export { SvgNewProjectIcon as ReactComponent };